module.exports = __webpack_public_path__ + "img/fi-street-food.2cdbf0f8.jpg";